/* eslint-disable no-irregular-whitespace */
import React from 'react';
import logoStone from '../../../../assets/icons/logo-stone.svg';
import { Content } from './styles';
import iconHand from '../../../../assets/icons/handOk.svg'
import { ContentContract } from './styles';
import Footer from '../../../Footer';
import Header from '../../../Header';
import HeaderFull from '../../../HeaderFull';

const TermOk: React.FC = () => {

  return (
    <>
      <HeaderFull />
      <Header />
      <ContentContract>
        <img src={logoStone} alt="Stone Logo" />
        <label>Gestão de Pagamentos Stone</label>
        <Content>
          <img src={iconHand} alt="Stone Logo" />
          <h2>Tudo certo por aqui!</h2>
          <h6>Você não possui termos pendentes.</h6>
          <a href={`${process.env.REACT_APP_API_ENDPOINT}`}>
            <button>Voltar para o portal</button>
          </a>
        </Content>
      </ContentContract>
      <Footer />
    </>
  );
};
export default TermOk;